(function() {
  var PopRangeKo, StepHandler,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  StepHandler = App.loadClass('grower::handlers/placement/StepHandler');

  PopRangeKo = App.loadClass('grower::viewmodels/placement/PopulationRange');

  exports.PopulationRangeHandler = (function(superClass) {
    extend(PopulationRangeHandler, superClass);

    function PopulationRangeHandler() {
      return PopulationRangeHandler.__super__.constructor.apply(this, arguments);
    }

    PopulationRangeHandler.prototype.inputSel = '';

    PopulationRangeHandler.prototype.addValidationRules = function() {
      return this.validator.registerRule({
        selector: '.validate-int',
        text: '%s must be a whole number',
        func: (function(_this) {
          return function(elem) {
            var val;
            val = $(elem).val();
            return !val || (!isNaN(val) && String(parseInt(val)) === val);
          };
        })(this)
      });
    };

    PopulationRangeHandler.prototype.getFieldAspect = function(fieldID, aspectID) {
      var aspectName, koData, retval;
      koData = this.stepKO.toJS();
      aspectName = this.taffyObjects.y_aspects({
        aspects_id: aspectID
      }).first().aspect_name;
      retval = {
        value: koData[this._autoAlias(aspectName)]
      };
      return retval;
    };

    PopulationRangeHandler.prototype.setFieldAspect = function(fieldAspect) {};

    PopulationRangeHandler.prototype.afterLoadLayout = function(sel, data) {
      var ref, ref1, ref2, use_rec_range_id;
      ko.cleanNode(this.parent.dialog.find('#spp_body')[0]);
      PopulationRangeHandler.__super__.afterLoadLayout.call(this, sel, data);
      this.stepKO = new PopRangeKo(this, this._getData());
      ko.applyBindings(this.stepKO, this.parent.dialog.find('#spp_body')[0]);
      use_rec_range_id = this.taffyObjects.y_aspects({
        aspect_name: 'Use Recommended Pop Range'
      }).first().aspects_id;
      this.getInputEl({
        aspect: use_rec_range_id
      }).on('click', (function(_this) {
        return function(el) {
          return _this.stepKO.use_recommended_pop_range(!$(el).is('.active'));
        };
      })(this));
      this.getInputEl({
        aspect: -use_rec_range_id
      }).on('click', (function(_this) {
        return function(el) {
          return _this.stepKO.use_recommended_pop_range($(el).is('.active'));
        };
      })(this));
      return this.parent.dialog.find('#company_name').text((ref = (ref1 = this.response) != null ? (ref2 = ref1.data) != null ? ref2.company_name : void 0 : void 0) != null ? ref : 'the seed company');
    };

    PopulationRangeHandler.prototype._getData = function() {
      var data, field_id, ref, ref1, ref10, ref11, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
      field_id = this.parent.taffyObjects.fields({
        selected: true
      }).first().id;
      data = {
        use_recommended_pop_range: (ref = (ref1 = this.parent.getFieldAspectByName(field_id, 'Use Recommended Pop Range')) != null ? ref1.value : void 0) != null ? ref : null,
        default_min_pop: (ref2 = (ref3 = this.response) != null ? (ref4 = ref3.data) != null ? ref4.company_min_pop : void 0 : void 0) != null ? ref2 : null,
        default_max_pop: (ref5 = (ref6 = this.response) != null ? (ref7 = ref6.data) != null ? ref7.company_max_pop : void 0 : void 0) != null ? ref5 : null,
        planting_min_pop: (ref8 = (ref9 = this.parent.getFieldAspectByName(field_id, 'Planting Min Pop')) != null ? ref9.value : void 0) != null ? ref8 : null,
        planting_max_pop: (ref10 = (ref11 = this.parent.getFieldAspectByName(field_id, 'Planting Max Pop')) != null ? ref11.value : void 0) != null ? ref10 : null
      };
      return data;
    };

    PopulationRangeHandler.prototype._autoAlias = function(aspectName) {
      return aspectName.toLowerCase().replace(/([^a-z0-9\s])/g, '').replace(/\s+/g, '_');
    };

    return PopulationRangeHandler;

  })(StepHandler);

}).call(this);
